import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';


// mui material
import {
    Badge,
    Box,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterListTwoTone';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';


// project import
import MainCard from 'ui-component/cards/MainCard';
import PaginationRows from 'ui-component/extended/PaginationRows';
import List from './List';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import Filter from './Filter';

const CustomizedBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px'
    }
}));

const BoardBookings = ({ boardUuid, viewType }) => {

    const theme = useTheme();
    const [total, setTotal] = useState(1);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [limit, setLimit] = useState(10);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState(false);
    let [filterCount, setFilterCount] = useState(0);
    const [filterObj, setFilterObj] = useState({
        start_date: '',
        end_date: '',
        uuid_user: [],
        uuid_board: boardUuid ? [boardUuid] : [],
        uuid_venue: [],
        booking_status: [],
        payment_status: [],
        payment_mode: [],
        payment_type: [],
        deleted: []
    });

    Object.keys(filterObj).forEach((keyName) => {
        if (keyName !== 'uuid_board') {
            if (filterObj[keyName] && filterObj[keyName].length) {
                filterCount += 1;
            }
        }
    });

    const changeSearch = (e) => {
        setSearchText(e.target.value);
        setPage(1);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handleClickOpenDialog = () => {
        setOpen(true);
    };

    const handleSuccess = (response) => {
        const data = response.data;
        setRows(data.rows);
        setTotal(data.filtered);
    };

    const getBookingListApi = useApi(VenueService.getBoardBookings, handleSuccess);

    useEffect(() => {
        getBookingListApi.execute({
            limit,
            skip: (page * limit) - limit,
            searchValue: searchText.trim(),
            filter: filterObj
        });
    }, [searchText, page, limit, reload, filterObj]);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard >
                <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                )
                            }}
                            value={searchText}
                            onChange={changeSearch}
                            placeholder="Search booking id..."
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={9} sx={{ textAlign: 'right', display: 'flex', justifyContent: 'end' }}>
                        {filterCount ? '' : <Typography variant='h4' sx={{ mt: 2, pr: 1 }}>No Filtered</Typography>}

                        <Tooltip title="Filter">
                            <IconButton
                                size="large"
                                onClick={handleClickOpenDialog}
                                sx={{ boxShadow: 'none', ml: 1, width: 55, height: 48, minHeight: 32 }}
                            >
                                <CustomizedBadge badgeContent={filterCount} color="error">
                                    <FilterListIcon sx={{ height: 48 }} />
                                </CustomizedBadge>
                            </IconButton>
                        </Tooltip>
                        <Filter
                            open={open}
                            handleCloseDialog={handleCloseDialog}
                            filterObj={filterObj}
                            setFilterObj={setFilterObj}
                            setPage={setPage}
                            viewType={viewType}
                        />
                    </Grid>
                </Grid>
                <List
                    rows={rows}
                    limit={limit}
                    page={page}
                    setReload={setReload}
                />
                <PaginationRows
                    total={total}
                    page={page}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    limits={[10, 15, 20]}
                />
            </MainCard>
        </Box>
    )
}

export default BoardBookings;
